import { render, staticRenderFns } from "./InfoModal.vue?vue&type=template&id=1710d958"
import script from "./InfoModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./InfoModal.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../../work/modules/node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {UiModal: require('/storage/data/jenkins/workspace/WEBPLATFORM/FRONTEND/PRESTIGIO-SOLUTIONS/PRESTIGIO-SOLUTIONS_Deploy_Prod/components/ui/UiModal.vue').default})
